import { Directive, OnInit, ElementRef } from '@angular/core';

@Directive({
	selector: '[AutoFocus]'
})
export class AutoFocusDirective implements OnInit {

	constructor(private elementRef: ElementRef) { }

	ngOnInit(): void {
		console.log("autofocus");
		setTimeout(() => this.elementRef.nativeElement.focus());
	}

}


// WEBPACK FOOTER //
// ./~/angular2-template-loader!./~/angular2-router-loader/src!./TypeScript/shared/directives/auto-focus.directive.ts